import React, { useEffect, useState } from 'react';
import { Layout } from 'antd';
import { Routes, Route, Navigate } from 'react-router-dom';
import ThankYou from '../../../pages/FormSubmissions/ThankYou';
import SurveyFlow from '../../../pages/FormSubmissions/SurveyFlow';
import SurveyIntro from '../../../pages/FormSubmissions/SurveyIntro';
import CampaignQuestionPage from '../../../pages/CampaingSubmissions/CampaignQuestionPage';

const { Content } = Layout;

const CampaingSurveyLayout  = () => {
 
  return (
    <Routes>
         <Route path=":campaignId" element={<SurveyFlow />} />
      <Route path="intro/:campaignId" element={<SurveyIntro />} />
      <Route path="question/:campaignId/:formId/:questionNumber" element={<CampaignQuestionPage />} />
      <Route path="thank-you/:campaignId" element={<ThankYou />} />
      <Route path="*" element={<Navigate to="/error" replace />} />


    

    

  
  </Routes>
  );
};

export default CampaingSurveyLayout ;